import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from '../../actions/authentication';
import { BookingBanner } from '../../components/BookingBanner';
import { useOfferBookingFormModalEnabled } from '../../hooks/offerBookingFormModal';
import { getIsAuthenticated } from '../../selectors/newbuilding';
import { TThunkDispatch } from '../../types/redux/thunk';
import { NewbuildingBrokerModalsContext } from '../NewbuildingBrokerModalsProvider';
import { trackBookingBannerClick, trackBookingBannerShow } from './tracking';

export const BookingBannerContainer: React.FC = () => {
  const isOfferBookingFormModalEnabled = useOfferBookingFormModalEnabled();
  const isAuthenticated = useSelector(getIsAuthenticated);
  const dispatch: TThunkDispatch = useDispatch();
  const { loadingPlace, startMicrofrontOpening } = React.useContext(NewbuildingBrokerModalsContext);

  const handleClick = React.useCallback(() => {
    trackBookingBannerClick();

    if (isAuthenticated) {
      startMicrofrontOpening('bookingBanner');

      return;
    }

    dispatch(
      requestAuthentication({
        onSuccess: () => () => startMicrofrontOpening('bookingBanner'),
      }),
    );
  }, [dispatch, isAuthenticated, startMicrofrontOpening]);

  if (!isOfferBookingFormModalEnabled) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={trackBookingBannerShow}>
      <BookingBanner loading={loadingPlace === 'bookingBanner'} onClick={handleClick} />
    </ActionAfterViewObserver>
  );
};
